import React, { useState, useEffect } from "react";
import { DatePicker } from 'antd';
import { RotateSpinner } from "react-spinners-kit";
import { BASE_URL, fromdate } from './apiConfig';
import Swal from 'sweetalert2';
import './CommonCSS.css'

export default function APIKeywiseSummaryreport() {
    const [guiuser, setguiuser] = useState("");
    const [showprogress, setshowprogress] = useState(false);
    const [SummaryapiData, setSummaryApiData] = useState([]);
    const [DistinctAPIData, setDistinctAPIData] = useState([]);
    const [DistinctIPData, setDistinctIPData] = useState([]);
   const [distinctSeller, setdistinctSeller] = useState([]);
    const [distinctuser, setdistinctuser] = useState([]);
        const [seller, setseller] = useState('');    const [apikeyvalue, setapikeyvalue] = useState('');
    const [ipvalue, setipvalue] = useState('');
    const [daterangevalue, setDateRangevalue] = useState('');

    const loginData = JSON.parse(sessionStorage.getItem("loginData"));
    const sessionusertype = loginData?.utype?.usertype;
    const sessionusername = loginData?.guiuserid;
    const sessionapiuser = loginData?.apiuserid;
    const apiDataLength = SummaryapiData?.length;
    //const apiDataLength = 1;
    const { RangePicker } = DatePicker;

    console.log("Logindata:" + sessionusername);
    console.log("usertype:" + sessionusertype)

    const today = new Date();
    // Calculate yesterday's date
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    // Format yesterday's date as 'YYYY-MM-DD'
    const formattedYesterday = yesterday.toISOString().split('T')[0];

    const [dateRange, setDateRange] = useState([]);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();

    const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const handleDateChange = (dates) => {
        setDateRangevalue(dates);
        // Update the state with the date range
        console.log("change Range" + dates);
        console.log("daterange:" + dateRange);

        const dateOnlyStrings = dates ? dates.map((dateString) => {
            const date = new Date(dateString);
            return date.toISOString().split("T")[0] || "2023-10-01";
        }) : ["2023-10-01", "2023-10-31"];

        let [sDate, eDate] = dateOnlyStrings;

        // Add one day to both start date and end date
        if (sDate) {
            const startDate = new Date(sDate);
            startDate.setDate(startDate.getDate() + 1);
            sDate = startDate.toISOString().split("T")[0];
        }

        if (eDate) {
            const endDate = new Date(eDate);
            endDate.setDate(endDate.getDate() + 1);
            eDate = endDate.toISOString().split("T")[0];
        }

        setStartDate(sDate);
        setEndDate(eDate);

        console.log("Inside start change:" + sDate);
        console.log("Inside end change:" + eDate);
    };

    const callDistinctGUIUser = async () => {
            let usr = "";
            if (seller !== "") {
                usr = seller;
            }
    
            else {
                usr = sessionusername;
            }
            const apiUrl = `${BASE_URL}/AllUsers?uid=${usr}&fromwhere=1`;
    
            const fetchOptions = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            };
            setshowprogress(true);
            try {
    
                const response = await fetch(apiUrl, fetchOptions);
                setshowprogress(false);
                if (!response.ok) {
                    throw new Error(`API request failed with status ${response.status}`);
                }
    
                const data = await response.json();
    
                const filteredData = data.filter(
                    (option) => String(option?.utype) === "2"
                );
    
                const filteredUserData = data.filter(
                    (option) => String(option?.utype) === "1"
                );
                console.log(data);
    
                if (seller === "") {
                    setdistinctSeller(filteredData);
                    setdistinctuser(filteredUserData);
                }
    
                else {
                    setdistinctuser(filteredUserData);
                }
            } catch (error) {
                setshowprogress(false);
                console.error("API Request Error:", error.message);
            }
        };
    const CallDistinctAPIKey = async () => {

        try {
            setshowprogress(true);
            const apiUrl = `${BASE_URL}/DistinctAPIKey`;
            const requestBody = {
                guiuserid: sessionusertype === 1 ? sessionusername : guiuser,
            };
            const fetchOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },

                body: JSON.stringify(requestBody),
            };

            const response = await fetch(apiUrl, fetchOptions);
            if (!response.ok) {
                setshowprogress(false);
                console.log(`API request failed with status ${response.status}`);
                const result = await Swal.fire({
                    title: 'API Request Error',
                    html: ("Request Failed with Status:" + response.status),
                    icon: 'error'
                });

                if (result.isConfirmed) {
                    setDistinctAPIData([]);
                }
                return;
            }


            // Check if response is not empty before parsing as JSON
            const responseText = await response.text();
            let data;
            if (responseText) {
                data = JSON.parse(responseText);
            } else {
                data = [];
            }

            if (data?.length > 0) {
                setDistinctAPIData(data);
            } else {
                setDistinctAPIData([]);
            }
            console.log(data);
            setshowprogress(false);
        }

        catch (error) {
            console.error("API Request Error:", error.message);
            setshowprogress(false);

            const result = await Swal.fire({
                title: 'API Request Error',
                html: error.message,
                icon: 'error'
            });
            if (result.isConfirmed) {

            }
            return;
        }
    };

    const distinctIP = async () => {
        console.log("called distinct ip...");
        try {
            setshowprogress(true);
            const apiUrl = `${BASE_URL}/DistinctIP`;
            const requestBody = {
                guserid: { guiuserid: sessionusertype === 1 ? sessionusername : guiuser },
                GenertaedSkey: apikeyvalue
            };
            const fetchOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },

                body: JSON.stringify(requestBody),
            };

            const response = await fetch(apiUrl, fetchOptions);
            if (!response.ok) {
                setshowprogress(false);
                console.log(`API request failed with status ${response.status}`);
                const result = await Swal.fire({
                    title: 'API Request Error',
                    html: ("Request Failed with Status:" + response.status),
                    icon: 'error'
                });

                if (result.isConfirmed) {
                    setDistinctIPData([]);
                }
                return;
            }


            // Check if response is not empty before parsing as JSON
            const responseText = await response.text();
            let data;
            if (responseText) {
                data = responseText ? JSON.parse(responseText) : [];
                console.log("Parsed Response Data:", data);
            } else {
                data = [];
            }
            console.log("inside now:" + data?.ipaddress);
            if (data?.ipaddress) {
                setDistinctIPData(data);


            } else {
                setDistinctIPData([]);
                console.log("No Data");
            }
            console.log(data);
            setshowprogress(false);
        }

        catch (error) {
            console.error("API Request Error:", error.message);
            setshowprogress(false);

            const result = await Swal.fire({
                title: 'API Request Error',
                html: error.message,
                icon: 'error'
            });
            if (result.isConfirmed) {

            }
            return;
        }
    }

    const CalldownloadRequestAPI = async () => {
        try {
            setshowprogress(true);
            if (!apikeyvalue || !ipvalue) {
                setshowprogress(false);
                const re = await Swal.fire({
                    title: "Value Error!",
                    text: "Please Fill All Field values as either API Key or IP  field not inputted",
                    icon: "error"
                })
            }

            else {
                const apiUrl = `${BASE_URL}/DownloadRequest`;
                const requestBody = {
                    filename: "APIKeySummary",
                    ecode: null,
                    guser: {
                        requser: sessionusername,
                        guiuserid: sessionusertype === 1 ? sessionapiuser : guiuser,
                        seckey: {
                            GenertaedSkey: apikeyvalue
                        },
                    },
                    sdate: formatDate(startDate),
                    edate: formatDate(endDate),
                    ip: ipvalue,
                    mno: {
                        mobileno: null
                    }
                };
                const fetchOptions = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },

                    body: JSON.stringify(requestBody),
                };

                const response = await fetch(apiUrl, fetchOptions);
                if (!response.ok) {
                    const errorMessage = response.statusText;
                    const responseBody = await response.text();
                    setshowprogress(false);
                    console.log(`API request failed with status ${response.status}`);
                    const result = await Swal.fire({
                        title: 'Download Request Error',
                        html: `${errorMessage}${responseBody}`,
                        icon: 'error'
                    });

                    if (result.isConfirmed) {
                        setSummaryApiData([]);
                        // Reset only when necessary
                    }
                    return;
                }

                else {
                    setshowprogress(false);
                    const result = await Swal.fire({
                        title: "Request Accepted Successfully!",
                        text: `Your API Key Summary Download Request is Accepted Successfully.Click on Top-Right Download Icon, to check Status and will get Download Link to download once file is available for Downloads.`,
                        icon: "success"
                    });

                    if (result.isConfirmed) {
                        setSummaryApiData([]);
                        setDistinctAPIData([]);
                        setDistinctIPData([]);
                        setguiuser('');
                        setapikeyvalue(''); // Reset only when necessary
                        setipvalue('');
                        setDateRange([]);
                        setDateRangevalue("");
                        setStartDate('');
                        setEndDate('');

                        // Reset only when necessary
                    }
                    return;
                }
            }
        }

        catch (error) {
            console.error("API Request Error:", error.message);
            setshowprogress(false);

            const result = await Swal.fire({
                title: 'Download request Error',
                html: error.message,
                icon: 'error'
            });
            if (result.isConfirmed) {
                setguiuser('');
                setapikeyvalue('');
                setDateRange([]);
                setDateRangevalue("");
            }
            return;
        }


    };


    useEffect(() => {
        if (sessionusertype !== 1) {
            callDistinctGUIUser();
        }

        else {
            setguiuser(sessionusername);
            CallDistinctAPIKey();

        }

    }, []);

         useEffect(() => {
                  if (sessionusertype !== 2) {
                      callDistinctGUIUser();
                  }
              }, []);
      
              useEffect(() => {
                  if (seller !== "" || sessionusertype === 2) {
                      callDistinctGUIUser();
                  }
              }, [seller,sessionusertype])

    useEffect(() => {
        if (guiuser !== "" && guiuser !== "All" && sessionusername !== guiuser) {
            CallDistinctAPIKey();
        }
        if (guiuser === "All") {
            setapikeyvalue("All");
            setipvalue("All");
        } else {
            setapikeyvalue(""); // Reset apikeyvalue when guiuser changes
            setipvalue("");     // Reset ipvalue when guiuser changes
        }
    }, [guiuser]);

    useEffect(() => {
        if (apikeyvalue && apikeyvalue !== "All") {
            distinctIP();
        }
        if (apikeyvalue === "All") {
            setipvalue("All");
        }

        else {
            setipvalue("");
        }
    }, [apikeyvalue]);

    // Split the IP addresses into an array
    const ipList = DistinctIPData?.ipaddress?.split(',') || [];

    const handleChange = (e) => {
        setipvalue(e.target.value);
    };

    const CallAPIKeySummary = async () => {
        try {
            setshowprogress(true);
            if (!apikeyvalue || !ipvalue) {
                setshowprogress(false);
                const re = await Swal.fire({
                    title: "Value Error!",
                    text: "Please Fill All Field values as either API Key or IP  field not inputted",
                    icon: "error"
                })
            }

            else {
                const apiUrl = `${BASE_URL}/APIKeySummary`;
                const requestBody = {
                    guser: {
                        requser: sessionusername,
                        guiuserid: sessionusertype === 1 ? sessionusername : guiuser,
                        seckey: {
                            GenertaedSkey: apikeyvalue
                        },
                    },
                    sdate: formatDate(startDate),
                    edate: formatDate(endDate),
                    ip: ipvalue
                };
                const fetchOptions = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },

                    body: JSON.stringify(requestBody),
                };

                const response = await fetch(apiUrl, fetchOptions);
                if (!response.ok) {
                    setshowprogress(false);
                    console.log(`API request failed with status ${response.status}`);
                    setSummaryApiData([]);
                } else {
                    const responseText = await response.text();
                    // Successful response logic
                    let data = [];
                    if (responseText) {
                        try {
                            data = JSON.parse(responseText);
                        } catch (parseError) {
                            console.error("JSON Parse Error:", parseError);
                        }
                    }

                    // Check if data is valid
                    if (!data || data.length === 0) {

                        console.log(`API request failed with status ${response.status}`);
                        setSummaryApiData([]);
                    } else {
                        // Populate data if valid
                        setSummaryApiData(data);
                    }
                    setshowprogress(false);
                }
            }
        }

        catch (error) {
            console.error("API Request Error:", error.message);
            setshowprogress(false);

            const result = await Swal.fire({
                title: 'API Request Error',
                html: error.message,
                icon: 'error'
            });
            if (result.isConfirmed) {
                setguiuser('');
                setapikeyvalue('');
                setDateRange([]);
                setDateRangevalue("");
            }
            return;
        }

    }

    return (
        <div className="maincontent-outermost">
            <div className="div-container" style={{ position: "relative" }}>
                <div className="row-container">
                    <span>API - Key Wise Summary Report</span>
                </div>

                {showprogress === true ? <div className="spinner-overlay">
                    <div className="custom-spinner"></div>
                </div> : <div></div>}

                <div className={showprogress === true ? "row-container blurred" : "row-container"}>
                    <div className="flex-div">
                        {sessionusertype === 0 && (
                            <div className="small-flex-div-first"  >

                                <label htmlFor="apiuser" >Select Seller</label>
                                {sessionusertype !== 1 ? (
                                    <select
                                        className="selectpicker form-control"
                                        value={seller}
                                        onChange={(e) => setseller(e.target.value)}
                                        style={{ textOverflow: "ellipsis", overflowWrap: "break-word", overflow: "hidden", whiteSpace: "nowrap" }}
                                    >
                                        <option value="" disabled >Select Seller</option>
                                        {distinctSeller?.map((option, index) => (
                                            <option
                                                key={index}
                                                value={option?.guiuserid}
                                                style={{
                                                    textOverflow: "ellipsis",
                                                    overflowWrap: "break-word",
                                                    overflow: "hidden",
                                                    whiteSpace: "nowrap",
                                                    marginLeft: "-1rem"
                                                }}
                                            >
                                                {option?.guiuserid}
                                            </option>
                                        ))
                                        }
                                    </select>
                                ) : (
                                    <input type="text" className="form-control" value={sessionusername} disabled />
                                )}


                            </div>
                        )}

                        <div className="small-flex-div-first" >

                            <label htmlFor="Countrycode" >API User </label>

{sessionusertype !== 1 ? (
                                               <select
                                                   className="selectpicker form-control"
                                                   value={guiuser}
                                                   onChange={(e) => setguiuser(e.target.value)}
                                                   style={{ textOverflow: "ellipsis", overflowWrap: "break-word", overflow: "hidden", whiteSpace: "nowrap" }}
                                               >
                                                   <option value="" disabled >Select User</option>
                                                   {distinctuser?.map((option, index) => (
                                                           <option
                                                               key={index}
                                                               value={option?.guiuserid}
                                                               style={{
                                                                   textOverflow: "ellipsis",
                                                                   overflowWrap: "break-word",
                                                                   overflow: "hidden",
                                                                   whiteSpace: "nowrap",
                                                                   marginLeft: "-1rem"
                                                               }}
                                                           >
                                                               {option?.guiuserid}
                                                           </option>
                                                       ))
                                                   }
                                               </select>
                                           ) : (
                                               <input type="text" className="form-control" value={sessionapiuser} disabled />
                                           )}


                        </div>


                        <div className="small-flex-div-first"  >

                            <label htmlFor="Countrycode" >API Key </label>
                            <select
                                className="selectpicker form-control"
                                value={guiuser === "All" ? "All" : apikeyvalue}
                                onChange={(e) => setapikeyvalue(e.target.value)}
                                style={{
                                    fontSize: "0.8rem",
                                    textOverflow: "ellipsis",
                                    overflowWrap: "break-word",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                }}
                                disabled={guiuser === "All"} // Disable the dropdown if guiuser is "All"
                            >
                                <option value="" disabled>Select API Key</option>
                                <option value="All">All</option>
                                {DistinctAPIData?.map((option, index) => (
                                    <option
                                        key={index}
                                        value={option?.genertaedSkey}

                                    >{option?.genertaedSkey}</option>
                                ))}
                            </select>

                        </div>

                        <div className="small-flex-div-first"  >
                            <label htmlFor="ip" >IP Address </label>
                            <select
                                className="selectpicker form-control"
                                disabled={guiuser === "All" || apikeyvalue === "All"}
                                value={(guiuser === "All" || apikeyvalue === "All") ? "All" : ipvalue}
                                onChange={handleChange}
                                style={{ textOverflow: "ellipsis", overflowWrap: "break-word", overflow: "hidden", whiteSpace: "nowrap" }}
                            >
                                <option>Select IP</option>
                                <option value="All">All</option>
                                {ipList?.map((ip, index) => (
                                    <option key={index} value={ip}>{ip}</option>
                                ))}
                            </select>
                        </div>


                        <div className='small-flex-div-first' style={{marginTop:"1rem"}}>
                            <label htmlFor="date" >Date Range</label>
                            <RangePicker
                                value={daterangevalue}
                                size="large"
                                className="neuromorphic-input"
                                onChange={handleDateChange}

                                style={{ border: "1px dotted black", width: "100%", height: "2.3rem" }}
                                disabledDate={(current) => {
                                    const fromDate = new Date(fromdate); // Replace with your actual fromdate
                                    const today = new Date();
                                    today.setHours(23, 59, 59, 999); // End of today's date

                                    // Disable dates before `fromDate` and after today
                                    return current && (current < fromDate || current > today);
                                }}
                            />

                        </div>
                    </div>

                </div>

                <div className={showprogress === true ? "row-container blurred" : "row-container"}>

                    <div className="button-file-div mt-3">
                        <button className='btn btn-dark mt-0' onClick={CallAPIKeySummary} >
                            <i class="fa-solid fa-file-lines mr-2" ></i>
                            <span>View Report</span></button>
                        <button className='btn btn-dark ' onClick={CalldownloadRequestAPI} >
                            <i class="fa-solid fa-download mr-1"></i><span>Download</span></button>
                    </div>

                </div>

                <div className={showprogress === true ? "row-container blurred table-responsive mt-1" : "row-container mt-1 table-responsive"}>
                    {SummaryapiData === null ? (
                        <div className="rowcontainer" style={{ justifyContent: "center" }}>
                            <div className="spinner-overlay">
                                <div className="custom-spinner"></div>
                            </div>
                        </div>
                    ) : (
                        apiDataLength === 0 ? (
                            <div className="img-report-div ">
                                <div className="img-div">
                                    <img src="images/NoReport.png" className="img-noreport" alt="No Report" />

                                </div>
                                <p style={{ marginLeft: "0rem", marginTop: "1rem", color: "grey" }}>
                                    No Report Found !!!
                                </p>
                            </div>
                        ) : (
                            <table className="table table-bordered mt-4" style={{ fontSize: "0.92rem" }}>

                                <thead style={{ backgroundColor: "skyblue" }}>
                                    <tr>
                                        <th>Date</th>
                                        <th>API User</th>
                                        <th>API Key</th>
                                        <th>IP Address</th>
                                        <th>Total Submit</th>
                                        <th>Total Delivered</th>
                                        <th>Total Failed</th>
                                        <th>Total Rejected</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* Render rows dynamically based on the data */}
                                    {SummaryapiData?.map((item, index) => {
                                        //    const isFirstRowForDate =
                                        //     index === 0 || SummaryapiData[index - 1]?.reqdate !== item?.reqdate;
                                        // const isFirstRowForUser =
                                        //     index === 0 || SummaryapiData[index - 1]?.guiid?.guiuserid !== item?.guiid?.guiuserid;
                                        // const isFirstRowForSkey =
                                        //     index === 0 || SummaryapiData[index - 1]?.genertaedSkey !== item?.genertaedSkey;
                                        // const userRowSpan = SummaryapiData.filter(
                                        //     i => i?.guiid?.guiuserid === item?.guiid?.guiuserid
                                        // ).length;

                                        // const skeyRowSpan = SummaryapiData.filter(
                                        //     i => i?.genertaedSkey === item?.genertaedSkey
                                        // ).length;

                                        // const DateRowSpan = SummaryapiData.filter(
                                        //     i => i?.reqdate === item?.reqdate
                                        // ).length;

                                        return (
                                            <tr key={index}>
                                                <td>{item?.reqdate}</td>
                                                <td>{item?.guiid?.guiuserid}</td>
                                                <td >{item?.api_ip?.genertaedSkey}</td>
                                                <td>{item?.api_ip?.ipaddress}</td>
                                                <td>{item?.totalSubmit}</td>
                                                <td>{item?.totalDelivered}</td>
                                                <td>{item?.totalFailed}</td>
                                                <td>{item?.totalRejected}</td>
                                            </tr>
                                        );
                                    })}


                                </tbody>
                            </table>
                        )
                    )}
                </div>
            </div>

        </div>
    );
}